// extracted by mini-css-extract-plugin
export default {"formGroup":"FormGroup_formGroup__WG-OO","ibtn":"FormGroup_ibtn__2neVR"};